'use strict';

import raven from 'raven';

import AddTransferController from './add-transfer.controller';
import AddTransferTpl from './add-transfer.html';
import SimpleMessages from 'app/controllers/simple-messages';

import { sortByNameProp } from 'app/helpers/sorting';

class CashboxTransfersController {
    /* @ngInject */
    constructor(
        CashboxTransfersService,
        OrderTranslationService,
        $mdDialog,
        $scope
    ) {
        Object.assign(this, {
            CashboxTransfersService,
            OrderTranslationService,
            $mdDialog,
            $scope
        });
        Object.assign(this, SimpleMessages);

        this.query = {
            include: [
                {
                    relation: 'src',
                    scope: {
                        include: ['employee']
                    }
                },
                {
                    relation: 'dst',
                    scope: {
                        include: ['employee']
                    }
                },
                'collection'
            ],
            where: {},
            limit: 10,
            page: 1,
            order: 'createdAt DESC',
            deleted: true
        };

        this.cashboxes = $scope.$parent.$resolve.cashboxes.sort(sortByNameProp);

        this.getModels();

        this.onPagination = () => {
            this.getModels();
        };

        this.onReorder = () => {
            this.getModels();
        };

    }

    afterFirstSave() {
        this.neverEditable = true;
    }

    getModels() {
        let qOpts = JSON.parse(JSON.stringify(this.query));

        if (this.mdOrder) {
            qOpts.order = this.OrderTranslationService.translate(
                this.mdOrder
            );
        }
        if (this.onlyNonCollected) {
            qOpts.where = Object.assign(qOpts.where, {
                collectable: true,
                collectionId: null,
            });
            qOpts.deleted = false;
        }
        let queryReady = this.CashboxTransfersService
            .customFind(qOpts)
            .then(cashboxTransfers => {
        
                this.cashboxTransfers = cashboxTransfers;
            });
        let countReady = this.CashboxTransfersService
            .getCount(qOpts)
            .then(result => {
                this.cashboxTransfersCount = result.count;
            });
        return Promise.all([queryReady, countReady]);
    }

    newCashboxTransfer(ev) {
        this.$mdDialog.show({
            controller: AddTransferController,
            template: AddTransferTpl,
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                cashboxes: this.cashboxes.filter(c => c.employeeId)
            }
        }).then(data => {
            console.debug(data);
            this.showNewTransferSpin = true;

            return this.CashboxTransfersService.create({
                amount: data.amount,
                srcId: 0,
                dstId: data.dstId,
                comments: data.comments,
                collectable: data.collectable
            }).then((result) => {
                this.showNewTransferSpin = false;
                const newTransfer = result.cashboxTransfer;
                newTransfer.dst = this.cashboxes.find(
                    c => c.id == newTransfer.dstId
                );
                this.cashboxTransfers.unshift(newTransfer);
                this.cashboxTransfersCount++;
                this.simpleSuccess();
            }, err => {
                this.showNewTransactionSpin = false;
                raven.captureException(err);
                this.simpleError();
            });
        });
    }

    isVoidable(cashboxTransfer) {
        if (cashboxTransfer.collectionId) {
            return false;
        }
        if (cashboxTransfer.deletedAt) {
            return false;
        }
        return true;
    }

    void($event, cashboxTransfer) {
        var confirm = this.$mdDialog.prompt()
            .title('Anulación de Transferencia')
            .textContent('Ingrese el motivo')
            .placeholder('Motivo de anulación')
            .ariaLabel('Motivo de anulación')
            .required(true)
            .targetEvent($event)
            .ok('Anular la transferencia')
            .cancel('Cancelar');

        this.$mdDialog.show(confirm).then(result => {
            this.showVoidSpin = true;
            this.CashboxTransfersService.void({
                id: cashboxTransfer.id,
                reason: result
            }).then(() => {
                this.showVoidSpin = false;
                cashboxTransfer.deletionReason = result;
                cashboxTransfer.deletedAt = new Date();
            }, err => {
                this.showVoidSpin = false;
                raven.captureException(err);
                this.simpleError();
            });
        });
    }
}

export default CashboxTransfersController;
